import { __makeTemplateObject } from "tslib";
import styled from '@emotion/styled';
import { css } from '@emotion/core';
export var MaxSizedDiv = styled.div(function (_a) {
    var _b = _a.maxWidth, maxWidth = _b === void 0 ? 1920 : _b;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-left: auto;\n    margin-right: auto;\n    ", "\n  "], ["\n    margin-left: auto;\n    margin-right: auto;\n    ", "\n  "])), maxWidth && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      max-width: ", "px;\n    "], ["\n      max-width: ", "px;\n    "])), maxWidth));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=MaxSizedDiv.js.map